import { CLOSE_TEXT_ALERT_PREFERENCES_BANNER, LOAD_TEXT_ALERT_SETTINGS_PAGE } from 'constants/ActionTypes';

export const loadTextAlertSettingsPage = () => ({ type: LOAD_TEXT_ALERT_SETTINGS_PAGE });

export const closeTextAlertPreferences = () => ({
  type: CLOSE_TEXT_ALERT_PREFERENCES_BANNER,
  textPreferencesBanner: {
    open: false,
    severity: '',
    message: '',
  },
});
